const { createApp, ref, computed, reactive, watch, onMounted } = Vue;
const fetchCollection = async (url, retries = 1) => {
  const attempt = async () => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status} for ${url}`);
    }
    if (response.headers.get('cf-mitigated')) {
      throw new Error(`Cloudflare challenge for ${url}`);
    }
    // Shopify liquid templates are served as text/html regardless of content,
    // so we rely on JSON.parse throwing if the body is a challenge page
    return response.json();
  };
  try {
    return await attempt();
  } catch (error) {
    if (retries > 0) {
      console.warn('Fetch failed, retrying after delay:', error.message);
      await new Promise(resolve => setTimeout(resolve, 2500));
      return attempt();
    }
    throw error;
  }
};
    const getWeekDays = (date) => date.day();
    const getNextSunday = (day) => (0 - day + 7) % 7;
    const getDeliveryDay = () => {
      let mondayDisabled = document.querySelector('.monday.disabled');
      console.log('mondayDisabled', mondayDisabled)
      if (mondayDisabled) {
        return 'Sunday';
      }
      return '';
    }
    const getDeliveredDateMonday = () => {
      let today = dayjs();
      //let today = dayjs('2025-12-10');
      // Calculate the number of days until the next Sunday
      const dayOfWeek = getWeekDays(today); // 0 is Sunday, 6 is Saturday
      const daysToNextSunday = getNextSunday(dayOfWeek);
      // Calculate the delivery date based on the current day
      let nextSunday = today.add(daysToNextSunday, "day");
      if (dayOfWeek === 2) {
        // its Tuesday. no need to do anything
      } else if (dayOfWeek !== 1) {
        // If it's wednesday, Thursday or Friday , schedule for the next Sunday.
        nextSunday = dayjs().day(dayOfWeek + 7 + daysToNextSunday);
      }
      nextSunday = nextSunday.add(1, "day"); // Add one day to get to Monday
      return nextSunday.format("dddd D MMMM YYYY");
    }

    const getDeliveredDate = (day = 'sunday') => {
      let today = dayjs();
      //let today = dayjs('2025-12-10');
      // Calculate the number of days until the next Sunday
      const dayOfWeek = getWeekDays(today); // 0 is Sunday, 6 is Saturday
      const daysToNextSunday = getNextSunday(dayOfWeek);
      // Calculate the delivery date based on the current day
      let nextSunday = today.add(daysToNextSunday, "day");
      if (dayOfWeek === 2) {
        // its Tuesday. no need to do anything
      } else if (dayOfWeek !== 1) {
        // If it's wednesday, Thursday or Friday , schedule for the next Sunday.
        nextSunday = dayjs().day(dayOfWeek + 7 + daysToNextSunday);
      }
      return nextSunday.format("dddd D MMMM YYYY");
    };


const countOccurrences = (products, propertyName) => {
  const counts = {};

  products
    .filter((product) => product[propertyName])
    .map((product) => product[propertyName])
    .forEach((value) => {
      counts[value] = (counts[value] || 0) + 1;
    });

  return counts;
};

const app = createApp({
  setup() {
    const products = reactive([]);
    const rProducts = reactive([]);
    const lProducts = reactive([]);
    const addOnProducts = reactive([]);
    const variants = reactive([]);
    const addOnVariants = reactive([]);
    const variant = ref({});
    const box = ref(6);
    const minBox = ref(6);
    const subscription = ref("");
    const addedProduct = ref(0);
    const addedAddOns = ref(0);
    const openFilter = ref(false);
    const toggleOrderSummary = ref(false);
    const filters = ref({});
    const checkoutBtn = ref("Checkout");
    const macros = ref({});
    const spice_level = ref({});
    const addon_types = ref({});
    const mealSize = ref("");
    const deliveryDay = ref("");
    const selectedMacro = ref("All");
    const selectedspice_level = ref("All");
    const selectedAddonType = ref("All");
    const orderPrice = ref(0);
    const perMealPrice = ref(0);
    const discountedPerMealPrice = ref(0);
    const addMoreMessage = ref("");
    const subscriptionTerm = ref("");
    // Get today's date
    const selectedDate = ref(getDeliveredDate());
    const sundayDate = ref(getDeliveredDate());
    const mondayDate = ref(getDeliveredDateMonday());
    const howManyLeft = computed(() => box.value - addedProduct.value);
    const productInCart = computed(() =>
      products.filter((product) => product.cart > 0)
    );
    const addOnsInCart = computed(() =>
      addOnProducts.filter((product) => product.cart > 0)
    );

    const filteredAddOnProducts = computed(() => {
      if (selectedAddonType.value === "All") {
        return addOnProducts;
      }
      return addOnProducts.filter((product) => {
        return product.addon_type === selectedAddonType.value;
      });
    });

    if (window.delayedDateForDelivery) {
      //add 3 weeks to sundayDate and mondayDate
      sundayDate.value = dayjs(window.delayedDateForDeliveryDate).add(25, 'day').format("dddd D MMMM YYYY");
      mondayDate.value = dayjs(window.delayedDateForDeliveryDate).add(26, 'day').format("dddd D MMMM YYYY");
    }

    /* calculate progress */
    const totalProgress = computed(() => 100 / box.value);
    const completedProgress = computed(
      () => totalProgress.value * addedProduct.value
    );
    // Create a computed property to filter the products based on selectedMacro and selectedspice_level
    const filteredProducts = computed(() => {
      return products.filter((product) => {
        if (
          selectedMacro.value === "All" ||
          product.macros === selectedMacro.value
        ) {
          if (
            selectedspice_level.value === "All" ||
            product.spice_level === selectedspice_level.value
          ) {
            return true;
          }
        }
        return false;
      });
    });

    const roundToTwo = (num) => {
      return Math.round((num + Number.EPSILON) * 100) / 100;
      //return parseFloat(num.toFixed(2))
      //return Math.ceil(num * 100) / 100;
    }

    const updateOrderPrice = () => {
      orderPrice.value = 0;
      perMealPrice.value = 0;
      discountedPerMealPrice.value = 0;
      subscriptionTerm.value = '';

      /*
      var totalItems = 0;
      productInCart.value.forEach((product) => {
        totalItems += parseInt(product.cart) || 0;
      });

      var orderTotal = 0;
      var listPrice = 0;
      productInCart.value.forEach((product) => {
        const productPriceCents = parseInt(product.price.replace(/\D/g,'')) || 0;
        const productPriceDollars = productPriceCents / 100; // Convert cents to dollars
        const productPrice = parseFloat(productPriceDollars) || 0;
        const productCart = parseInt(product.cart) || 0;
        var lineItemPrice = productPrice * productCart;
        listPrice += lineItemPrice;
        if (totalItems > 8) {
          const discountedPrice = getDiscountedPrice(totalItems, mealSize.value);
          const discountedLineItemPrice = lineItemPrice - (lineItemPrice * discountedPrice);
          lineItemPrice = discountedLineItemPrice
          if (subscription.value === "subscribe") {
            lineItemPrice = discountedLineItemPrice * 0.8; // 20% off for subscription
          }
        }
        orderTotal += parseFloat(lineItemPrice) || 0;
      });
      orderTotal = roundToTwo(orderTotal);
      if (subscription.value === "subscribe") {
        subscriptionTerm.value = ' for the first 3 orders';
      }
 
      if (totalItems >= 8) {
        //discountedPerMealPrice.value = (orderTotal / addedProduct.value).toFixed(2);
      }

      orderPrice.value = roundToTwo(orderTotal).toFixed(2);
      perMealPrice.value = roundToTwo((listPrice / addedProduct.value)).toFixed(2);
      */
      
      
      var totalPrice = productInCart.value.reduce((acc, product) => {
        const productPriceCents = parseInt(product.price.replace(/\D/g,'')) || 0;
        const productPriceDollars = productPriceCents / 100; // Convert cents to dollars
        const productPrice = parseFloat(productPriceDollars) || 0;
        const productCart = parseInt(product.cart) || 0;
        return acc + productPrice * productCart;
      }, 0);
      
      // Add add-ons to total price
      var addOnsPrice = addOnsInCart.value.reduce((acc, product) => {
        const productPriceCents = parseInt(product.price.replace(/\D/g,'')) || 0;
        const productPriceDollars = productPriceCents / 100; // Convert cents to dollars
        const productPrice = parseFloat(productPriceDollars) || 0;
        const productCart = parseInt(product.cart) || 0;
        return acc + productPrice * productCart;
      }, 0);
      
      //totalPrice = roundToTwo(totalPrice);
      orderPrice.value = totalPrice;
      //console.log('orderPrice', orderPrice.value)
      perMealPrice.value = (totalPrice / addedProduct.value);
      //console.log('perMealPrice', perMealPrice.value)
      if (addedProduct.value >= 8) {
        let thisDiscountedPrice = getDiscountedPrice(addedProduct.value, mealSize.value);
        //console.log('thisDiscountedPrice', thisDiscountedPrice)
        orderPrice.value = (orderPrice.value - (orderPrice.value * thisDiscountedPrice))
        discountedPerMealPrice.value = ( (orderPrice.value / addedProduct.value))
      }
      //console.log('orderPrice after discount', orderPrice.value)
      //console.log('discountedPerMealPrice', discountedPerMealPrice.value)
      if (subscription.value === "subscribe") {
        orderPrice.value = (orderPrice.value * 0.8) // 20% off for subscription
        discountedPerMealPrice.value = (orderPrice.value / addedProduct.value)
        subscriptionTerm.value = ' for the first 3 orders';
      }
      
      // Add add-ons price to the final total
      orderPrice.value = orderPrice.value + addOnsPrice;
      
      orderPrice.value = parseFloat(roundToTwo(orderPrice.value).toFixed(2));
      perMealPrice.value = parseFloat(roundToTwo(perMealPrice.value).toFixed(2));
      discountedPerMealPrice.value = parseFloat(roundToTwo(discountedPerMealPrice.value).toFixed(2));

      addMoreMessage.value = getAddMoreMessage(addedProduct.value);
    
    }

    const getAddMoreMessage = (addedProductValue) => {
      let howManyLeft = parseInt(8 - addedProductValue);
      let message = '';
      const isEven = howManyLeft => ((howManyLeft % 2) == 0);
      let mealTerm = isEven(howManyLeft) ? 'meals' : 'meal';
      //console.log('addedProductValue', addedProductValue)
      if (addedProductValue < 6) {
        message = `Add 6 meals to your box to checkout.`;
      }
      else if (addedProductValue >= 6 && addedProductValue < 8) {
        message = `Add ${howManyLeft} more ${mealTerm} to save an extra £0.10 per meal.`;
      }
      else if (addedProductValue >= 8 && addedProductValue < 10) {
        howManyLeft = 10 - addedProductValue;
        message = `Add ${howManyLeft} more ${mealTerm} to save an extra £0.20 per meal.`;
      }
      else if (addedProductValue >= 10 && addedProductValue < 12) {
        howManyLeft = 12 - addedProductValue;
        message = `Add ${howManyLeft} more ${mealTerm} to save an extra £0.30 per meal.`;
      }
      else if (addedProductValue >= 12 && addedProductValue < 18) {
        howManyLeft = 18 - addedProductValue;
        message = `Add ${howManyLeft} more ${mealTerm} to save an extra £0.10 per meal.`;
      }
      else if (addedProductValue >= 18) {
        message = ``;
      }
      /*if (subscription.value === "one_time") {
        message += " Subscribe for 20% more off!";
      }*/
      return message;
    }

    const getDiscountedPrice = (addedProductValue,size) => {
      //console.log('addedProductValue', addedProductValue)
      //console.log('size', size)
      if (size=== 'large') {  
        if (addedProductValue >= 8 && addedProductValue < 10) {
          return 0.0101;
        } else if (addedProductValue >= 10 && addedProductValue < 12) {
          return 0.0301;
        } else if (addedProductValue >= 12 && addedProductValue < 18 ) {
          return 0.0602;
        } else if (addedProductValue >= 18) {
          return 0.0702;
        }
      } else {
        if (addedProductValue >= 8 && addedProductValue < 10) {
          return 0.0134;
        } else if (addedProductValue >= 10 && addedProductValue < 12) {
          return 0.0401;
        } else if (addedProductValue >= 12 && addedProductValue < 18) {
          return 0.0802;
        } else if (addedProductValue >= 18) {
          return 0.0935;
        }
      }
    }

    const increaseCart = (id) => {
      const index = products.findIndex((p) => p.id === id);
      if (index === -1) {
        return;
      }

      products[index].cart += 1;
      addedProduct.value++;
      //console.log('addedProduct', addedProduct.value)
      updateOrderPrice();
    };

    const decreaseCart = (id) => {
      const index = products.findIndex((p) => p.id === id);

      if (
        index === -1 ||
        addedProduct.value <= 0 ||
        products[index].cart <= 0
      ) {
        return;
      }

      products[index].cart -= 1;
      addedProduct.value--;
      updateOrderPrice();
    };

    const increaseAddOnCart = (id) => {
      const index = addOnProducts.findIndex((p) => p.id === id);
      if (index === -1) {
        return;
      }

      addOnProducts[index].cart += 1;
      addedAddOns.value++;
      updateOrderPrice();
    };

    const decreaseAddOnCart = (id) => {
      const index = addOnProducts.findIndex((p) => p.id === id);

      if (
        index === -1 ||
        addedAddOns.value <= 0 ||
        addOnProducts[index].cart <= 0
      ) {
        return;
      }

      addOnProducts[index].cart -= 1;
      addedAddOns.value--;
      updateOrderPrice();
    };

    const updateBox = (selected) => {
      box.value = parseInt(selected.title, 10);
      variant.value = { ...selected };
    };

    const updateSubscription = (type) => {
      subscription.value = type;
      scrollToBoxsWrapper(".continue-btn");
    };

    const updateMealSize = (size) => {
      mealSize.value = size;
      fetchProductData();
      addedProduct.value = 0; // Reset addedProduct to 0 when changing meal size
      // Reset the productInCart to clear previous selections
      productInCart.value.forEach((product) => {
        product.cart = 0;
      });
      resetOrderSummary();
      scrollToBoxsWrapper(".delivery-day");
    };

    const updateDeliveryDay = (day) => {
      deliveryDay.value = day;
      scrollToBoxsWrapper(".purchase-type");
    };

    const addCart = async () => {
      //console.log('addCart')
      //console.log('variant', variant.value)
      //console.log('productInCart', productInCart.value)
      checkoutBtn.value = "Preparing...";
      // Combine with getCartItems function
      function getCartItems() {
        const cartItems = productInCart.value;

        if (cartItems.length === 0) {
          return "No items in the cart.";
        }

        return cartItems
          .map((product) => `${product.cart}x ${product.title}`)
          .join(", ");
      }

      let thisVariant = variants.find(
        (v) => v.title && v.title.toLowerCase() === mealSize.value
      );

      let chosenVariant = thisVariant.variants.find(
        (v) => v.title === deliveryDay.value
      );

      let bundleProductData = {
        variantId: chosenVariant.id,
        productId: thisVariant.productId,
        handle: thisVariant.handle,
      };

      let selections = productInCart.value.map((p) => {
        return {
          collectionId: p.collectionId,
          externalProductId: p.id,
          externalVariantId: p.externalVariantId,
          quantity: p.cart,
        };
      });

      //console.log('subscription', subscription.value)

      if (subscription.value === "subscribe") {
        selections = productInCart.value.map((p) => {
          return {
            collectionId: p.collectionId,
            externalProductId: p.id,
            externalVariantId: p.externalVariantId,
            quantity: p.cart,
            sellingPlan: p.selling_plan,
          };
        });
      }

      const bundle = {
        externalVariantId: bundleProductData.variantId,
        externalProductId: bundleProductData.productId,
        selections: [...selections],
      };

      let firstDelivery = deliveryDay.value === 'Monday' ? mondayDate.value : sundayDate.value;
      const cartItems = await recharge.bundle.getDynamicBundleItems(bundle,bundleProductData.handle);
      const orderNote = 'Delivery Day: ' + deliveryDay.value + ', First Delivery: ' + firstDelivery;
      const cartData = { items: cartItems, note: orderNote};

      console.log('cart items');
      console.log(cartItems);
      
      //log(cartData)

      /*cartData.items.push({
        'id': 41566892032055,
        'quantity': 2,
        "selling_plan": 1987248183,
        });*/

      // Add add-on products to cart
      console.log('addOnsInCart',addOnsInCart.value)
      if (addOnsInCart.value.length > 0) {
        if (subscription.value === "subscribe") {
          // For subscriptions, process add-ons through recharge bundle
          if (addOnVariants.length > 0) {
            // Add-ons have only one variant (no delivery day variants)
            const addOnBox = addOnVariants[0];

            if (addOnBox && addOnBox.variants && addOnBox.variants.length > 0) {
              const addOnChosenVariant = addOnBox.variants[0];

              const addOnBundleProductData = {
                variantId: addOnChosenVariant.id,
                productId: addOnBox.productId,
                handle: addOnBox.handle,
              };

              const addOnSelections = addOnsInCart.value.map((p) => {
                return {
                  collectionId: p.collectionId,
                  externalProductId: p.id,
                  externalVariantId: p.externalVariantId,
                  quantity: p.cart,
                  sellingPlan: p.selling_plan,
                };
              });

              const addOnBundle = {
                externalVariantId: addOnBundleProductData.variantId,
                externalProductId: addOnBundleProductData.productId,
                selections: [...addOnSelections],
              };

              const addOnCartItems = await recharge.bundle.getDynamicBundleItems(
                addOnBundle,
                addOnBundleProductData.handle
              );

              console.log('addOnCartItems');
              console.log(addOnCartItems);

              // Add the processed add-on items to the cart
              cartData.items.push(...addOnCartItems);
            }
          }
        } else {
          // For one-time purchases, add add-ons directly
          addOnsInCart.value.forEach((addOn) => {
            cartData.items.push({
              id: addOn.externalVariantId,
              quantity: addOn.cart,
            });
          });
        }
      }

      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartData),
      });
      checkoutBtn.value = "Checkout";
      window.location.href = "/account/register";
    };

    const toggleModal = (handle) => {
      //console.log(handle) 
      // Define the URL of the webpage you want to fetch
      const url = `/products/${handle}?view=quickview`;
      const info = (content = null) => {
        document.querySelector("#quick-content").innerHTML = content;
      };

      // Use the fetch function to request the HTML content
      fetch(url)
        .then((response) => {
          // Check if the request was successful (status code 200)
          if (response.status === 200) {
            // Parse the response as text
            info();
            return response.text();
          } else {
            throw new Error("Failed to fetch the HTML content");
          }
        })
        .then((html) => {
          info(html);
          const modalElement = document.querySelector("#quick-view-modal");
          console.log(modalElement);

          if (modalElement) {
            modalElement.setAttribute("open", "");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
    // update the macros and spice_level
    const updateMacrosAndspice_level = () => {
      macros.value = countOccurrences(filteredProducts.value, "macros");
      spice_level.value = countOccurrences(filteredProducts.value, "spice_level");

      filters.value = {
        //Macros: macros.value,
        spice_level: spice_level.value,
      };
      console.log(filteredProducts.value)
    };

    const selectedFilter = (name, value) => {
      const selected = name === "Macros" ? selectedMacro : selectedspice_level;

      selected.value = selected.value === value ? "All" : value;

      updateMacrosAndspice_level();
    };

    const updateAddonTypes = () => {
      addon_types.value = countOccurrences(addOnProducts, "addon_type");
      console.log('addon_types', addon_types.value);
    };

    const selectAddonType = (value) => {
      selectedAddonType.value = selectedAddonType.value === value ? "All" : value;
      console.log('selectedAddonType', selectedAddonType.value);
    };

    fetchProductData();

    function fetchProductData() {
      const selectedMealSize = mealSize.value === "large" ? "large" : "regular";
      const inMemory = selectedMealSize === "large" ? lProducts : rProducts;

      // Already have data for this meal size — switch immediately, no fetch needed
      if (inMemory.length > 0) {
        products.length = 0;
        products.push(...inMemory);
        updateMacrosAndspice_level();
        return;
      }

      const sizeUrl = selectedMealSize === "large"
        ? "/collections/large-meals-box?view=view-json"
        : "/collections/regular-meals-box?view=view-json";

      const fetches = [fetchCollection(sizeUrl)];
      if (addOnProducts.length === 0) {
        fetches.push(fetchCollection("/collections/add-on-collection?view=view-json"));
      }

      Promise.all(fetches)
        .then(([sizeData, addOnsData]) => {
          if (sizeData && sizeData.products) {
            products.length = 0;
            products.push(...sizeData.products);

            if (selectedMealSize === "large") {
              lProducts.length = 0;
              lProducts.push(...sizeData.products);
            } else {
              rProducts.length = 0;
              rProducts.push(...sizeData.products);
            }

            // Append this size's box variants, avoiding duplicates on repeated calls
            if (sizeData.boxs) {
              const existingHandles = new Set(variants.map(v => v.handle));
              sizeData.boxs
                .filter(b => !existingHandles.has(b.handle))
                .forEach(b => variants.push(b));
            }
          }

          if (addOnsData && addOnsData.products) {
            addOnProducts.length = 0;
            addOnProducts.push(...addOnsData.products);
            updateAddonTypes();
            addOnVariants.length = 0;
            if (addOnsData.boxs) {
              addOnVariants.push(...addOnsData.boxs);
            }
          }

          updateMacrosAndspice_level();
        })
        .catch(error => {
          console.error('Failed to load product data:', error);
        });
    }

    function scrollToBoxsWrapper(target) {
      const boxsWrapper = document.querySelector(target);
      if (boxsWrapper) {
        requestAnimationFrame(() => {
          let yOffset = -50;
          if (target.indexOf("continue-btn")>-1) {
            yOffset = 100;
          }
          const y = boxsWrapper.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
          //boxsWrapper.scrollIntoView({ behavior: "smooth" });
        });
      }
    }

    /*
    watch(subscription, () => {
      scrollToBoxsWrapper(".continue-btn");
    });

    watch(deliveryDay, () => {
      scrollToBoxsWrapper(".purchase-type");
    });

    watch(mealSize, () => {
      scrollToBoxsWrapper(".delivery-day");
    });*/

    onMounted(() => {
      deliveryDay.value = getDeliveryDay();
    });

    const step = ref('step1');
    const changeStep = (newStep) => {
      resetOrderSummary();
      step.value = newStep;
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Optional: smooth scrolling animation
      });
    }

    const goToAddOns = () => {
      changeStep('step3');
    }

    const skipAddOns = () => {
      addCart();
    }

    const resetOrderSummary = () => {
      orderPrice.value = 0;
      perMealPrice.value = 0;
      discountedPerMealPrice.value = 0;
      updateOrderPrice();
    }

    const clearCart = async () => {
      const response = await fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error("Network response was not ok clearing cart");
      }
    }

    clearCart();

    return {
      products,
      filteredProducts,
      addOnProducts,
      filteredAddOnProducts,
      addOnsInCart,
      variants,
      box,
      minBox,
      variant,
      subscription,
      mealSize,
      deliveryDay,
      addedProduct,
      addedAddOns,
      productInCart,
      howManyLeft,
      orderPrice,
      perMealPrice,
      discountedPerMealPrice,
      addMoreMessage,
      selectedDate,
      sundayDate,
      mondayDate,
      openFilter,
      selectedMacro,
      selectedspice_level,
      selectedAddonType,
      addon_types,
      filters,
      toggleOrderSummary,
      completedProgress,
      checkoutBtn,
      subscriptionTerm,
      selectedFilter,
      selectAddonType,
      increaseCart,
      decreaseCart,
      increaseAddOnCart,
      decreaseAddOnCart,
      updateBox,
      updateSubscription,
      updateMealSize,
      updateDeliveryDay,
      addCart,
      toggleModal,
      step,
      changeStep,
      goToAddOns,
      skipAddOns,
    };
  }
});

app.mount("#box-app");

// Go Back to home page
function goHomePage() {
  window.location.href = "/"
}
let closeBox = document.querySelector('.box-close');
closeBox.addEventListener('click', goHomePage );

// Back button
function stepBackButton(){
  var completedElements = document.querySelectorAll(".steps-wrap .completed");

  if (completedElements.length > 0) {
    var lastCompletedChild = completedElements[completedElements.length - 1];
    lastCompletedChild.click();
  }else{
    window.location.href = "/"
  }
}
let backBTN = document.querySelector('.back-btn');
backBTN.addEventListener('click', stepBackButton);